module.exports = __webpack_public_path__ + "img/listbg2.b74129f7.png";